import $ from 'jquery';
import { createFocusTrap } from 'focus-trap';
import { updateFiltersResetLink, updateSortResetLink } from './facets-utils';
const FADE_DURATION = 400;
const body = $('body');
const container = $('.js-collnav-section');
const filterTrigger = $('#js-filter-trigger');
const modal = $('#js-filter-modal');
const sortTrigger = $('#js-sort-trigger');
const closeButton = $('.js-filter-close');
const facetsFilter = $('.facets__wrapper');
const facetsSort = $('.facet-filters.sorting');
const sortOptions = $('.js-sort-options');
const resetSort = $('.js-sort-reset');
const resetFilter = $('.js-filter-reset');
const applyFilter = $('.js-filter-apply');
const collectionNav = $('.js-collection-nav');
const announcementBar = $('.js-announcement-bar');
// Create a fallback trap that just implements the methods we actually use
const dummyTrap = {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    activate: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    deactivate: ()=>{}
};
let focusTrap;
let firstOpen = true;
let isModalOpen = false;
const toggleModalA11y = (trigger)=>{
    trigger.attr('aria-expanded', isModalOpen.toString());
};
focusTrap = dummyTrap;
export const closeModal = ()=>{
    modal.fadeOut(FADE_DURATION, ()=>{
        firstOpen = true;
    });
    focusTrap.deactivate();
    container.removeClass('open');
    body.removeClass('is-frozen is-filter-open is-sort-open');
    filterTrigger.removeClass('open');
    sortTrigger.removeClass('open');
    isModalOpen = false;
    toggleModalA11y(filterTrigger);
    toggleModalA11y(sortTrigger);
};
// Now that closeModal is defined, initialize focusTrap properly
focusTrap = container.length > 0 && container[0] instanceof HTMLElement ? createFocusTrap(container[0], {
    allowOutsideClick: ()=>{
        focusTrap.deactivate() // Now safe to use
        ;
        return true;
    },
    onDeactivate: ()=>{
        closeModal();
    }
}) : dummyTrap;
const scrollToTop = ()=>{
    var _announcementBar_, _collectionNav_;
    const announcementBarHeight = ((_announcementBar_ = announcementBar[0]) === null || _announcementBar_ === void 0 ? void 0 : _announcementBar_.getBoundingClientRect().height) || 0;
    const collectionNavHeight = ((_collectionNav_ = collectionNav[0]) === null || _collectionNav_ === void 0 ? void 0 : _collectionNav_.getBoundingClientRect().height) || 0;
    const top = announcementBarHeight + collectionNavHeight;
    window.scrollTo({
        top,
        behavior: 'auto'
    });
};
const isElementVisible = (element)=>{
    var _element_;
    if (!element.length) {
        return false;
    }
    const rect = (_element_ = element[0]) === null || _element_ === void 0 ? void 0 : _element_.getBoundingClientRect();
    if (!rect) {
        return false;
    }
    return rect.bottom > 0 && rect.top < window.innerHeight;
};
export const init = async function() {
    const showModal = ()=>{
        if (firstOpen) {
            modal.fadeIn(FADE_DURATION);
            firstOpen = false;
        } else {
            modal.show();
        }
        focusTrap.activate();
        container.addClass('open');
        body.addClass('is-frozen');
        isModalOpen = true;
    };
    const openFilters = ()=>{
        sortTrigger.removeClass('open');
        filterTrigger.addClass('open');
        showModal();
        facetsSort.hide();
        facetsFilter.show();
        resetFilter.show();
        applyFilter.show();
        resetSort.hide();
        body.removeClass('is-sort-open');
        body.addClass('is-filter-open');
        toggleModalA11y(filterTrigger);
    };
    const openSort = ()=>{
        filterTrigger.removeClass('open');
        sortTrigger.addClass('open');
        showModal();
        facetsFilter.hide();
        facetsSort.show();
        resetFilter.hide();
        applyFilter.hide();
        resetSort.show();
        body.removeClass('is-filter-open');
        body.addClass('is-sort-open');
        toggleModalA11y(sortTrigger);
    };
    filterTrigger.on('click', function() {
        if (sortTrigger.hasClass('open')) {
            openFilters();
        } else {
            filterTrigger.hasClass('open') ? closeModal() : openFilters();
        }
        if (isElementVisible(collectionNav)) {
            scrollToTop();
        }
    });
    sortTrigger.on('click', function() {
        if (filterTrigger.hasClass('open')) {
            openSort();
        } else {
            sortTrigger.hasClass('open') ? closeModal() : openSort();
        }
        if (isElementVisible(collectionNav)) {
            scrollToTop();
        }
    });
    closeButton.on('click', closeModal);
    applyFilter.on('click', function() {
        closeModal();
        scrollToTop();
    });
    resetSort.on('click', function() {
        sortOptions.find('input').each(function() {
            $(this).prop('checked', false);
        });
        const urlParams = new URLSearchParams(window.location.search);
        updateFiltersResetLink(urlParams.toString());
        scrollToTop();
    });
    resetFilter.on('click', function() {
        const urlParams = new URLSearchParams(window.location.search);
        updateSortResetLink(urlParams.toString());
    });
    sortOptions.each(function() {
        $(this).on('click', function() {
            closeModal();
            scrollToTop();
        });
    });
    const urlParams = new URLSearchParams(window.location.search);
    updateFiltersResetLink(urlParams.toString());
    updateSortResetLink(urlParams.toString());
};
